import { AudienceGroupTargetingCondition } from './AudienceGroup'

export interface Bid {
  pricingModel: string
  amount: number
  currency: string
}

export interface AdGroupSummary {
  id: string
  sequentialId: number
  bid: Bid | null
  targetings: Targeting[]
}

export type Targeting =
  | TreatmentTargeting
  | LanguageTargeting
  | GenderTargeting
  | AgeTargeting
  | AreaTargeting
  | ConcernTargeting
  | AudienceGroupTargeting

export enum TargetingType {
  TREATMENT = 'TREATMENT',
  CONCERN = 'CONCERN',
  LANGUAGE = 'LANGUAGE',
  GENDER = 'GENDER',
  AGE_RANGE = 'AGE_RANGE',
  AREA = 'AREA_CODE',
  AUDIENCE_GROUP = 'AUDIENCE_GROUP',
}
export interface TreatmentTargeting {
  id: string
  type: TargetingType.TREATMENT
  value: number
}

export interface ConcernTargeting {
  id: string
  type: TargetingType.CONCERN
  value: number
}

export enum Language {
  KOREAN = 'ko',
  JAPANESE = 'ja',
}
export interface LanguageTargeting {
  id: string
  type: TargetingType.LANGUAGE
  value: Language
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export interface GenderTargeting {
  id: string
  type: TargetingType.GENDER
  value: Gender
}

export enum AgeRange {
  FROM_15_TO_19 = 'FROM_15_TO_19',
  FROM_20_TO_24 = 'FROM_20_TO_24',
  FROM_25_TO_29 = 'FROM_25_TO_29',
  FROM_30_TO_34 = 'FROM_30_TO_34',
  FROM_35_TO_39 = 'FROM_35_TO_39',
  FROM_40 = 'FROM_40',
}

export interface AgeTargeting {
  id: string
  type: TargetingType.AGE_RANGE
  value: AgeRange
}

export interface AreaTargeting {
  id: string
  type: TargetingType.AREA
  value: string
}

export interface AudienceGroupTargeting {
  id: string
  type: TargetingType.AUDIENCE_GROUP
  value: {
    id: string
    condition: AudienceGroupTargetingCondition
  }
}

export interface AdGroup {
  id: string
  campaignId: string
  targetings: Targeting[]
  bid: Bid
}
